document.addEventListener("DOMContentLoaded", () => {
    const mediaQuery = window.matchMedia("(min-width: 990px)"),
        applyHoverListeners = () => {
            document.querySelectorAll("header-menu details").forEach((details) => {
                mediaQuery.matches
                    ? (details.addEventListener("mouseenter", handleMouseEnter),
                      details.addEventListener("mouseleave", handleMouseLeave))
                    : (details.removeEventListener("mouseenter", handleMouseEnter),
                      details.removeEventListener("mouseleave", handleMouseLeave));
            });
        };
    function handleMouseEnter(e) {
        this.leaveTimeout && clearTimeout(this.leaveTimeout), this.setAttribute("open", "");
        const summary = this.querySelector("summary");
        summary && summary.setAttribute("aria-expanded", "true");
    }
    function handleMouseLeave(e) {
        this.leaveTimeout = setTimeout(() => {
            this.removeAttribute("open");
            const summary = this.querySelector("summary");
            summary && summary.setAttribute("aria-expanded", "false");
        }, 250);
    }
    applyHoverListeners(), mediaQuery.addEventListener("change", applyHoverListeners);
});


//  Variant Image Filter Start
(function() {
  // Smart keyword extractor that ignores generic prefixes
  function getKeyword(colorName, url) {
    if (!url) return cleanString(colorName);
    let fn = url.split('/').pop().split('?')[0].toLowerCase();
    
    // 1. Try to find a word from the color name in the filename
    const words = cleanString(colorName).split(/\s+/).filter(w => w.length > 2);
    const matchedWord = words.find(w => fn.includes(w));
    if (matchedWord) return matchedWord;

    // 2. Strip generic product terms to isolate the color keyword
    const generic = ['product', 'spfit', 'crosskix', 'shoe', 'mens', 'women', 'tetra', 'swatch', 'color', 'lateral', 'image', 'copy', 'back', 'front', 'top', 'bottom', 'iso'];
    generic.forEach(term => {
      fn = fn.replace(new RegExp(term, 'g'), '');
    });

    // 3. Extract the first remaining alphabetical string
    const m = fn.match(/([a-zA-Z]+)/);
    return m ? m[1] : cleanString(colorName);
  }

  // Helper to normalize and clean strings
  function cleanString(str) {
    if (!str) return '';
    return str.trim()
              .toLowerCase()
              .replace(/[™®©]/g, '')
              .replace(/\s+/g, ' ');
  }

  function filterImages() {
    document.querySelectorAll('section[id^="shopify-section-template"]').forEach(section => {
      const wrapper = section.querySelector('.color-variant-wrapper') || 
                      Array.from(section.querySelectorAll('.product-form__input'))
                           .find(el => /colo?ur/i.test(el.querySelector('legend')?.textContent));
      if (!wrapper) return;

      // 1. Map color names to swatch keywords and build full clean list
      const map = {};
      const inputs = Array.from(wrapper.querySelectorAll('input[type="radio"], option'));
      const allColors = inputs.map(el => cleanString(el.value || el.textContent)).filter(Boolean);

      inputs.forEach(el => {
        const val = cleanString(el.value || el.textContent);
        const idClean = el.id.trim();
        const label = Array.from(wrapper.querySelectorAll('label')).find(l => l.getAttribute('for')?.trim() === idClean);
        const img = label?.querySelector('img');
        map[val] = img ? getKeyword(val, img.src || img.dataset.src) : val;
      });

      // 2. Get active selected color name and mapped keyword
      const selected = wrapper.querySelector('input[type="radio"]:checked, select');
      if (!selected) return;
      const activeColor = cleanString(selected.value || selected.options[selected.selectedIndex]?.text || '');
      const activeKeyword = map[activeColor];
      if (!activeColor) return;

      // 3. Filter main media items and thumbnails
      const getImgData = item => {
        const img = item.querySelector('img');
        if (!img) return { alt: '', fn: '' };
        
        // Prioritize lazyloaded data attributes or srcset over blank src spacer URLs
        let src = img.getAttribute('data-srcset') || 
                  img.getAttribute('data-src') || 
                  img.getAttribute('srcset') || 
                  img.getAttribute('src') || '';
        
        if (src.startsWith('data:')) {
          src = img.getAttribute('data-src') || img.getAttribute('src') || '';
        }

        const alt = img.getAttribute('alt') || img.alt || '';
        const fn = src.split('/').pop().split('?')[0].toLowerCase();
        return { alt: cleanString(alt), fn };
      };

      let firstBtn = null;
      section.querySelectorAll('.product__media-item, .thumbnail-list__item').forEach(item => {
        const { alt, fn } = getImgData(item);
        if (!fn) return;

        let matchColor = null;

        // Try matching alt text first, fallback to filename keyword
        if (allColors.includes(alt)) {
          matchColor = alt;
        } else {
          for (const [color, kw] of Object.entries(map)) {
            if (kw && fn.includes(kw)) {
              matchColor = color;
              break;
            }
          }
        }

        const isMatch = matchColor ? (matchColor === activeColor) : true;
        
        // Clear any previous inline styles and set display property
        if (item.classList.contains('product__media-item')) {
          item.style.display = isMatch ? '' : 'none';
          item.style.opacity = '';
          item.style.pointerEvents = '';
          item.style.width = '';
          item.style.height = '';
          item.style.position = '';
          item.style.overflow = '';
        } else {
          item.style.display = isMatch ? '' : 'none';
        }

        if (isMatch && item.classList.contains('thumbnail-list__item') && !firstBtn) {
          firstBtn = item.querySelector('button');
        }
      });

      // 4. Reset Dawn's native sliders and trigger active media click
      section.querySelectorAll('slider-component').forEach(s => typeof s.initPages === 'function' && s.initPages());
      if (firstBtn) firstBtn.click();
    });
  }

  // Bind change events globally to document
  document.addEventListener('change', e => {
    if (e.target.matches('.variant-option-wrapper input[type="radio"]') || e.target.matches('select[name="Color"], select[name="color"]')) {
      filterImages(); // Run instantly
      setTimeout(filterImages, 50); // Backup run to catch DOM upgrades
    }
  });

  // Subscribe to variant changes
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, () => {
      filterImages(); // Run instantly on variant load
      setTimeout(filterImages, 150); // Backup run
    });
  }

  // Initial load runs
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      filterImages();
      setTimeout(filterImages, 150);
    });
  } else {
    filterImages();
    setTimeout(filterImages, 150);
  }
})();

//  Variant Image Filter End